export enum BadgeType {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  INFORMATION = 'information',
  NEUTRAL = 'neutral',
  EXPIRED = 'expired',
}
